import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { CommonModule, NgFor, NgIf } from '@angular/common'
import { HttpClient } from '@angular/common/http'
import { ReactiveFormsModule } from '@angular/forms'
import { eps } from '../../../../services/url.service'
import { Observable } from 'rxjs'
import { FormBuilder, FormGroup, NgModel, Validators } from '@angular/forms'
import { FormsModule } from '@angular/forms'
import { map } from 'rxjs/operators'
import { PaginationComponent } from '../../../template/pagination/pagination.component'
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe'
import { User } from '../../../../store/auth/auth.state'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { AttendancePolicyService } from '../../../../services/attendance-policy.service'
import { UserService } from '../../../../services/user.service'
import { ToastrService } from 'ngx-toastr'
import { NgSelectModule } from '@ng-select/ng-select'
import { LoaderComponent } from '../../../../shared/components/loader/loader.component'
import { createAction, props, Store } from '@ngrx/store'
import { UtilsService } from '../../../../services/utils.service'
// import { NgModel } from '@angular/forms';
interface AttendancePolicy {
  id: string
  title: string
  description: string
  shiftType: string
  shiftStartTime: Date
  shiftEndTime: Date
  date: string
  disabled: boolean
  business: {
    id: string
    businessName: string
  }
  businessId: string
  isDefault: boolean
}

@Component({
  selector: 'app-attendance-policy-details',
  standalone: true,
  templateUrl: './attendance-policy-details.component.html',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    NgIf,
    NgFor,
    RouterModule,
    CommonModule,
    PaginationComponent,
    CapitalizePipe,
    NgSelectModule
  ]
})
export class AttendancePolicyDetailsComponent implements OnInit {
  eps = eps

  private modalService = inject(NgbModal)
  private attendancePolicyService = inject(AttendancePolicyService)
  form!: FormGroup
  // export const deleteAssignedTo = createAction('[Role] Delete Assigned To', props<{ id: string }>())
  currentStep = 1
  steps = [1, 2, 3] // Steps for the form
  isBreakHoursStatus = false
  isSingleClockInStatus = false
  isMinimumWorkHoursStatus = false
  isSelfieStatus = false
  firstClockInTimeStatus = false
  isLossOfPayStatus = true
  selectedBusiness: string | null = null
  isMarkedLateStatus = false
  EditHoliday: AttendancePolicy | null = null
  assignLeavePolicyform!: FormGroup
  DeleteId!: string

  noEmployee: any
  assignments: any
  search: any
  getAttendancePolicyList() {
    throw new Error('Method not implemented.')
  }
  // getErrorMessage(arg0: string) {
  //   throw new Error('Method not implemented.');
  // }

  private route = inject(ActivatedRoute)
  private http = inject(HttpClient)

  policyId!: string

  policy$!: Observable<any>
  assignedEmployees$!: Observable<any[]>

  idForEdit = ''
  isLoading = false

  assignedEmployees: any[] = [] // current page data
  allAssignedEmployees: any[] = [] // full data

  currentPage = 1
  pageLimit = 10
  totalCount = 0
  pageLastRecord = 0
  noRecords: any | null
  assignAttendancePolicyform!: FormGroup

  public employeeList: User[] = []

  // assignAttendancePolicyform!: FormGroup

  businesses$!: Observable<any[]>
  selectedBusinessId: string | null = null

  modalPolicyList: any[] = []
  // employeeList: any[] = []

  minDate!: string
  // isLoading = false
  constructor(
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    // private attendancePolicyService: AttendancePolicyService,
    private userService: UserService,
    private toastr: ToastrService,
    private utilService: UtilsService
  ) { }
  ngOnInit() {
    this.form = this.fb.group({})
    // this.route.paramMap.subscribe(params => {
    //   this.policyId = params.get('policyId') as string;

    //   if (!this.policyId) return;

    //   this.policy$ = this.http.get(
    //     `${eps.attendance.policiesApi}/${this.policyId}`
    //   );

    //   this.loadAssignedEmployees();

    // this code is added by shivam
    this.route.paramMap.subscribe(params => {
      this.policyId = params.get('policyId') as string

      if (!this.policyId) return

      this.policy$ = this.http.get(`${eps.attendance.policiesApi}/${this.policyId}`)

      this.loadAssignedEmployees()

      // ✅ FORMAT startDate properly for input
      this.assignedEmployees$ = this.http
        .get<any[]>(`${eps.attendance.assignedPolicyApi}/policy/${this.policyId}`)
        .pipe(
          map((data: any[]) =>
            data.map(item => {
              let formattedDate = null

              if (item.startDate) {
                const d = new Date(item.startDate)
                if (!isNaN(d.getTime())) {
                  const pad = (n: number) => n.toString().padStart(2, '0')
                  formattedDate = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
                }
              }

              return {
                ...item,
                startDate: formattedDate
              }
            })
          )
        )

      this.assignAttendancePolicyform = this.fb.group({
        employeeIds: [[], Validators.required],
        assignmentDate: ['', Validators.required],
        endDate: ['', Validators.required]
      })

      this.policy$.subscribe((policy: any) => {
        if (!policy) return
        this.selectedBusinessId = policy.businessId
        this.loadEmployees()
      })
    })

    // ✅ FORMAT startDate properly for input
    // this.assignedEmployees$ = this.http.get<any[]>(
    //   `${eps.attendance.assignedPolicyApi}/policy/${this.policyId}`
    // ).pipe(
    //   map((data: any[]) =>
    //     data.map(item => {
    //       let formattedDate = null;

    //       if (item.startDate) {
    //         const d = new Date(item.startDate);
    //         if (!isNaN(d.getTime())) {
    //           const pad = (n: number) => n.toString().padStart(2, '0');
    //           formattedDate = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    //         }
    //       }

    //       return {
    //         ...item,
    //         startDate: formattedDate
    //       };
    //     })
    //   )
    // );

    // this code is added by shivam
    // this.assignedEmployees = this.assignedEmployees.sort((a, b) => {
    //   const nameA = `${a.user?.firstName || ''} ${a.user?.lastName || ''}`.toLowerCase();
    //   const nameB = `${b.user?.firstName || ''} ${b.user?.lastName || ''}`.toLowerCase();

    //   return nameA.localeCompare(nameB);
    // });
    // });

    // this code is add by shivam
    // this.assignAttendancePolicyform = this.fb.group({
    //   employeeIds: [[], Validators.required],
    //   attendancePolicyId: ['', Validators.required],
    //   businessId: ['', Validators.required],
    //   assignmentDate: ['', Validators.required]
    // })

    this.policy$.subscribe(policy => {
      if (policy) {
        this.assignAttendancePolicyform.patchValue({
          attendancePolicyId: policy.id
        })
      }
    })
    // min date (tomorrow)
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    this.minDate = tomorrow.toISOString().split('T')[0]
  }

  // this code is added by shivam
  // this method used to show start date in the input feild if user already have start date in database then show that date in the feild if not show empty date feild
  formatDateForInput(date: string | Date): string {
    const d = new Date(date)

    const year = d.getFullYear()
    const month = ('0' + (d.getMonth() + 1)).slice(-2)
    const day = ('0' + d.getDate()).slice(-2)
    const hours = ('0' + d.getHours()).slice(-2)
    const minutes = ('0' + d.getMinutes()).slice(-2)

    return `${year}-${month}-${day}T${hours}:${minutes}`
  }
  // for edit the Date
  editStartDate(assignment: any) {
    this.idForEdit = assignment.id
  }

  // ----- Code Ended--------

  openBusiness(content: unknown) {
    this.modalService.open(content, { scrollable: false, centered: true, size: 'lg' })
  }
  onClose() {
    // this.getAttendancePolicyList();
    this.form.reset()
    this.assignAttendancePolicyform.reset()
    this.modalService.dismissAll()
    this.currentStep = 1
    this.isBreakHoursStatus =
      this.isLossOfPayStatus =
      this.isMarkedLateStatus =
      this.isMinimumWorkHoursStatus =
      this.isSelfieStatus =
      this.isSingleClockInStatus =
      false
    this.cdr.detectChanges() // force UI update
    this.selectedBusiness = null
    this.getAttendancePolicyList()
    this.loadAssignedEmployees()
  }

  onPageChange(page: number) {
    this.currentPage = page
    this.updatePaginatedData()
  }

  saveEndDate(assignment: any) {
    if (!assignment?.id || !assignment.endDate) return

    const payload = {
      endDate: assignment.endDate
    }

    this.isLoading = true

    this.http.put(`${eps.attendance.assignedPolicyApi}/${assignment.id}`, payload).subscribe({
      next: () => {
        this.isLoading = false
        this.idForEdit = ''
        console.log('End date updated in DB')
      },
      error: err => {
        this.isLoading = false
        console.error(err)
      }
    })
  }

  // this code is wriiten by shivam
  onAssign() {
    if (this.assignAttendancePolicyform.valid) {
      const payload = {
        employeeIds: this.assignAttendancePolicyform.value.employeeIds,
        // attendancePolicyId: this.assignAttendancePolicyform.value.attendancePolicyId,
        attendancePolicyId: this.policyId,
        businessId: this.assignAttendancePolicyform.value.businessId,
        startDate: this.assignAttendancePolicyform.value.assignmentDate,
        endDate: this.assignAttendancePolicyform.value.endDate

      }

      this.attendancePolicyService.assignPolicy(payload).subscribe({
        next: () => {
          this.toastr.success('SUCCESS', 'Policy assigned successfully!')
          this.loadAssignedEmployees()
          this.assignAttendancePolicyform.reset()
          this.onClose()
        },
        // error: (error: any) => {
        //   this.toastr.error(error.message)
        // }
        error: (error: any) => {
          const message =
            error?.error?.message ||
            error?.message ||
            'Something went wrong'

          this.toastr.error(message)
        }
      })
    }
  }

  getDashboardRoute(): string {
    // return this.user?.role.name === 'Admin' ? eps.dashboardPath : eps.employeeDashboardPath
    return this.utilService.getDashboardRoute()
  }

  getErrorMessage(controlName: string): string | null {
    const control = this.assignAttendancePolicyform.get(controlName)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
    }
    return null
  }

  // onSearchEmployee() {
  //   const term = this.search.toLowerCase();

  //   let filtered = this.allAssignedEmployees;

  //   // ✅ FILTER
  //   if (term) {
  //     filtered = this.allAssignedEmployees.filter(item => {
  //       const name = `${item.user?.firstName || ''} ${item.user?.lastName || ''}`.toLowerCase();
  //       return name.includes(term);
  //     });
  //   }

  //   this.noEmployee = filtered.length === 0;

  //   // ✅ REMOVE null users
  //   filtered = filtered.filter(item => item.user);

  //   // ✅ SORT (A → Z)
  //   filtered = filtered.sort((a, b) => {
  //     const nameA = `${a.user.firstName} ${a.user.lastName}`.toLowerCase();
  //     const nameB = `${b.user.firstName} ${b.user.lastName}`.toLowerCase();

  //     return nameA.localeCompare(nameB);
  //   });

  //   // ✅ UPDATE DATA
  //   this.totalCount = filtered.length;
  //   this.currentPage = 1;

  //   this.assignedEmployees = filtered.slice(0, this.pageLimit);
  // }

  //   onSearchEmployee() {
  //   const term = this.search.toLowerCase();

  //   let filtered = this.allAssignedEmployees;

  //   // ✅ FILTER BY NAME
  //   if (term) {
  //     filtered = filtered.filter(item => {
  //       const name = `${item.user?.firstName || ''} ${item.user?.lastName || ''}`.toLowerCase();
  //       return name.includes(term);
  //     });
  //   }

  //   // null user remove by filter method
  //   filtered = filtered.filter(item => item.user);

  //   //
  //   this.noEmployee = term.length > 0 && filtered.length === 0;

  //   // this method is use to sort the employee by there Name
  //   filtered = filtered.sort((a, b) => {
  //     const nameA = `${a.user.firstName} ${a.user.lastName}`.toLowerCase();
  //     const nameB = `${b.user.firstName} ${b.user.lastName}`.toLowerCase();

  //     return nameA.localeCompare(nameB);
  //   });

  //   // updated Data
  //   this.totalCount = filtered.length;
  //   this.currentPage = 1;
  //   this.assignedEmployees = filtered.slice(0, this.pageLimit);
  // }

  onSearchEmployee() {
    const term = this.search?.toLowerCase() || ''

    // ✅ REMOVE null users FIRST
    let filtered = this.allAssignedEmployees.filter(item => item.user)

    // ✅ FILTER
    if (term) {
      filtered = filtered.filter(item => {
        const name = `${item.user.firstName} ${item.user.lastName}`.toLowerCase()
        return name.includes(term)
      })
    }

    // ✅ EMPTY CHECK
    this.noEmployee = term.length > 0 && filtered.length === 0

    // ✅ SORT
    filtered.sort((a, b) => {
      const nameA = `${a.user.firstName} ${a.user.lastName}`.toLowerCase()
      const nameB = `${b.user.firstName} ${b.user.lastName}`.toLowerCase()
      return nameA.localeCompare(nameB)
    })

    // ✅ UPDATE
    this.totalCount = filtered.length
    this.currentPage = 1
    this.assignedEmployees = filtered.slice(0, this.pageLimit)
  }

  onChangeBusinessPolicyList() {
    this.attendancePolicyService.list(this.selectedBusinessId ?? '').subscribe(res => {
      this.modalPolicyList = res.attendancePolicies
    })
  }

  // onChangeEmployeeList(event: any) {
  //   const businessId = this.selectedBusinessId

  //   if (!businessId) return

  //   this.userService.getEmployees(`businessId=${businessId}`).subscribe(res => {
  //     this.employeeList = res.users
  //   })
  // }

  onChangeEmployeeList() {
    this.selectedBusinessId = this.assignAttendancePolicyform.get('businessId')?.value
    this.loadEmployees()
  }

  onEmployeeSelect(selectedItems: any[]) {
    const employeeIds = selectedItems.map(item => item.id)
    this.assignAttendancePolicyform.get('employeeIds')?.setValue(employeeIds)
  }

  onAssignmentDateChange(event: any) {
    const selectedDate = new Date(event.target.value)

    const today = new Date()
    today.setHours(0, 0, 0, 0)

    const tomorrow = new Date(today)
    tomorrow.setDate(today.getDate() + 1)

    if (selectedDate < tomorrow) {
      alert('Please select a date from tomorrow onwards')

      this.assignAttendancePolicyform.patchValue({
        assignmentDate: null
      })

      return
    }

    this.assignAttendancePolicyform.patchValue({
      assignmentDate: event.target.value
    })
  }


  onEndDateChange(event: any) {
    const selectedEndDate = new Date(event.target.value)

    const startDate = new Date(
      this.assignAttendancePolicyform.value.assignmentDate
    )

    startDate.setHours(0, 0, 0, 0)
    selectedEndDate.setHours(0, 0, 0, 0)

    if (selectedEndDate <= startDate) {
      alert('End date must be greater than assignment date')

      this.assignAttendancePolicyform.patchValue({
        endDate: null
      })

      return
    }

    this.assignAttendancePolicyform.patchValue({
      endDate: event.target.value
    })
  }

  customSearchFn(term: string, item: any) {
    return item.businessName.toLowerCase().includes(term.toLowerCase())
  }

  customSearchFnEmployee(term: string, item: any) {
    return `${item.firstName} ${item.lastName}`.toLowerCase().includes(term.toLowerCase())
  }

  // code end here

  // loadAssignedEmployees() {
  //   this.http.get<any>(
  //     `${eps.attendance.assignedPolicyApi}/policy/${this.policyId}?page=${this.currentPage}&limit=${this.pageLimit}`
  //   ).subscribe((res: any) => {

  //     console.log('API RESPONSE:', res); // ✅ DEBUG

  //     // ✅ FIX: assign directly
  //     this.assignedEmployees = res.data || res;

  //     this.totalCount = res.totalCount || this.assignedEmployees.length;

  //     this.pageLastRecord = Math.min(
  //       this.currentPage * this.pageLimit,
  //       this.totalCount
  //     );
  //   });
  // }

  loadAssignedEmployees() {
    this.http
      .get<any[]>(`${eps.attendance.assignedPolicyApi}/policy/${this.policyId}`)
      .subscribe((res: any[]) => {
        console.log('API RESPONSE:', res)

        console.log('Policy ID:', this.policyId)
        console.log('RAW API:', res)

        // this.allAssignedEmployees = res || []

        // this method only sort the employee by there name

        // this.allAssignedEmployees.sort((a, b) => {
        //   const nameA = `${a?.user?.firstName || ''} ${a?.user?.lastName || ''}`.toLowerCase();
        //   const nameB = `${b?.user?.firstName || ''} ${b?.user?.lastName || ''}`.toLowerCase();

        //   return nameA.localeCompare(nameB);
        // });

        // this method sort the employe by name as well as filter out the null value
        // this.allAssignedEmployees = res.filter(item => item.user) // ✅ FIX
        // this.allAssignedEmployees = (res || [])
        //   .filter(item => item.user) // with the filter method we can remove null value
        //   .sort((a, b) => {
        //     const nameA = `${a.user.firstName} ${a.user.lastName}`.toLowerCase()
        //     const nameB = `${b.user.firstName} ${b.user.lastName}`.toLowerCase()
        //     return nameA.localeCompare(nameB)
        //   })
        this.allAssignedEmployees = (res || [])
          .filter(item => item.user)
          .sort((a, b) => {
            const nameA = `${a.user.firstName} ${a.user.lastName}`.toLowerCase()
            const nameB = `${b.user.firstName} ${b.user.lastName}`.toLowerCase()
            return nameA.localeCompare(nameB)
          })

        console.log('SORTED:', this.allAssignedEmployees)
        // full data
        // this.totalCount = res.length;
        this.totalCount = this.allAssignedEmployees.length

        this.updatePaginatedData()
        this.loadEmployees()

        console.log('VISIBLE:', this.assignedEmployees)
      })
  }

  // updatePaginatedData() {
  //   const start = (this.currentPage - 1) * this.pageLimit;
  //   const end = start + this.pageLimit;

  //   this.assignedEmployees = this.allAssignedEmployees.slice(start, end);

  //   this.pageLastRecord = Math.min(end, this.totalCount);
  // }

  // updatePaginatedData() {
  //   const start = (this.currentPage - 1) * this.pageLimit;
  //   const end = start + this.pageLimit;

  //   this.assignedEmployees = this.allAssignedEmployees.slice(start, end) || [];

  //   this.pageLastRecord = Math.min(end, this.totalCount);
  // }

  updatePaginatedData() {
    const start = (this.currentPage - 1) * this.pageLimit
    const end = start + this.pageLimit

    this.assignedEmployees = this.allAssignedEmployees.slice(start, end)

    this.pageLastRecord = Math.min(end, this.totalCount)
  }
  // ✅ Save updated startDate
  saveStartDate(assignment: any) {
    if (!assignment?.id || !assignment.startDate) return

    const payload = {
      startDate: assignment.startDate
    }

    this.isLoading = true

    this.http.put(`${eps.attendance.assignedPolicyApi}/${assignment.id}`, payload).subscribe({
      next: () => {
        this.isLoading = false
        this.idForEdit = ''
        console.log('Start date updated in DB')
      },
      error: err => {
        this.isLoading = false
        console.error(err)
      }
    })
  }

  //   getEmployeeList() {
  //   this.userService
  //     .getEmployees(
  //       `businessId=${this.selectedBusiness}&search=${this.search}&page=${this.currentPage}&limit=${this.pageLimit}`
  //     )
  //     .subscribe({
  //       next: (response: any) => {

  //         // ✅ STEP 1: assign data
  //         let employees = response.users || [];

  //         // ✅ STEP 2: SORT (name wise)
  //         employees = employees.sort((a: any, b: any) => {
  //           const nameA = `${a.firstName || ''} ${a.lastName || ''}`.toLowerCase();
  //           const nameB = `${b.firstName || ''} ${b.lastName || ''}`.toLowerCase();

  //           return nameA.localeCompare(nameB);
  //         });

  //         // ✅ STEP 3: assign to UI
  //         this.employeeList = employees;

  //         // ✅ pagination info
  //         this.totalCount = response.totalCount;
  //         this.pageLastRecord = Math.min(
  //           this.currentPage * this.pageLimit,
  //           this.totalCount
  //         );
  //       },

  //       error: (error: any) => {
  //         this.toastr.error('Error: ' + error.message);
  //       }
  //     });
  // }

  // ✅ Cancel edit
  cancelEdit() {
    this.idForEdit = ''
  }

  // deleteAssignment(id: string) {
  //   console.log('Delete clicked:', id);
  // }

  deleteAssignment(id: string) {
    // if (!id || !confirm('Delete this assignment?')) return;
    this.attendancePolicyService.deleteAssignment(id).subscribe({
      next: () => {
        this.allAssignedEmployees = this.allAssignedEmployees.filter(a => a.id !== id)
        this.assignedEmployees = this.assignedEmployees.filter(a => a.id !== id)
        this.totalCount = this.allAssignedEmployees.length
        this.updatePaginatedData()
        this.loadEmployees()
        console.log('Deleted successfully')
      },
      error: err => {
        console.error('Delete failed:', err)
        alert('Delete failed!')
      }
    })
  }

  loadEmployees() {
    const businessId =
      this.assignAttendancePolicyform.get('businessId')?.value || this.selectedBusinessId

    if (!businessId) {
      this.employeeList = []
      return
    }

    this.userService.getEmployees(`businessId=${businessId}`).subscribe({
      next: (res: any) => {
        const assignedIds = new Set(
          (this.allAssignedEmployees || []).map(a => a.user?.id).filter(Boolean)
        )

        this.employeeList = (res.users || [])
          .filter((emp: any) => !assignedIds.has(emp.id))
          .sort((a: any, b: any) => {
            const nameA = `${a.firstName || ''} ${a.lastName || ''}`.toLowerCase()
            const nameB = `${b.firstName || ''} ${b.lastName || ''}`.toLowerCase()
            return nameA.localeCompare(nameB)
          })

        console.log('Filtered Employee List:', this.employeeList)
      },
      error: (err: any) => {
        console.error(err)
        this.employeeList = []
      }
    })
  }

  openDelete(content: unknown, id: string) {
    this.DeleteId = id
    this.modalService.open(content, { scrollable: false, centered: true, size: 'sm' })
  }

  confirmDelete() {
    if (this.DeleteId) {
      this.attendancePolicyService.deleteAssignment(this.DeleteId).subscribe(() => {
        this.allAssignedEmployees = this.allAssignedEmployees.filter(a => a.id !== this.DeleteId)
        this.updatePaginatedData()
        this.loadEmployees()
        this.toastr.success('SUCCESS', 'Assignment deleted successfully!')
      })
      this.onClose()
    }
  }
}
